import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    MonitoringGetStatsCourierResponse,
    MonitoringGetStatsParams,
    MonitoringGetStatsResponse,
} from '@/new-services/types/monitoring'

type ApiGetStatsResponse = Promise<AxiosResponse<MonitoringGetStatsResponse>>
type ApiGetStatsCourierResponse = Promise<AxiosResponse<MonitoringGetStatsCourierResponse>>

export function getDeliveries(params: MonitoringGetStatsParams): ApiGetStatsResponse {
    return http.get('/dispatcher/api/monitoring/deliveries', { params })
}

export function getTakes(params: MonitoringGetStatsParams): ApiGetStatsResponse {
    return http.get('/dispatcher/api/monitoring/order-takes', { params })
}

export function getCouriers(params: MonitoringGetStatsParams): ApiGetStatsCourierResponse {
    return http.get('/dispatcher/api/monitoring/couriers', { params })
}

export default {
    getDeliveries,
    getTakes,
    getCouriers,
}
